import EditIcon from "@redotech/redo-icons/edit-02.svg";
import { RedoButton } from "@redotech/redo-web/arbiter-components/buttons/redo-button";
import { memo } from "react";
import { useNavigate } from "react-router-dom";

export const UpsellInspector = memo(function UpsellInspector({
  upsellId,
  doSave,
}: {
  upsellId: string;
  doSave?: () => void;
}) {
  const navigate = useNavigate();

  return (
    <RedoButton
      hierarchy="secondary"
      IconLeading={() => <EditIcon />}
      onClick={() => {
        doSave?.();
        navigate(`./upsell-page-builder/${upsellId}`);
      }}
      text="Edit"
    />
  );
});
